import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ButtonPrimary from '../Buttons/Button';

const BaseLayoutCtaContainer = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.indent ? '4rem 1fr' : '1fr')};
  grid-gap: ${(props) => (props.indent ? '1.5rem' : '0')};
  margin-top: 2.5rem;

  @media only screen and (max-width: 992px) {
    grid-template-columns: 1fr;
    grid-gap: 1rem;
    padding-top: 2.5rem;
    margin-top: auto;
  }
`;

const BaseLayoutCtaContent = styled.div`
  display: ${(props) => (props.fullWidth ? 'grid' : 'flex')};
  grid-gap: ${(props) => (props.fullWidth ? '1rem' : 0)};
  align-items: center;

  @media only screen and (max-width: 992px) {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 1rem;
  }
`;

const BaseLayoutCtaExtra = styled.div`
  margin-left: ${(props) => (props.fullWidth ? '0' : '0.5rem')};

  @media only screen and (max-width: 992px) {
    margin-left: 0;
    text-align: center;
  }
`;

const BaseLayoutCta = ({
  indent,
  buttonProps = {
    type: 'button',
  },
  content,
  mt,
  mb,
  fullWidth,
}) => (
  <BaseLayoutCtaContainer mt={mt} mb={mb} indent={indent}>
    {indent && <div />}
    <BaseLayoutCtaContent fullWidth={fullWidth}>
      <ButtonPrimary
        type={buttonProps.type}
        Icon={buttonProps.icon}
        title={buttonProps.title}
        onClick={buttonProps.onClick}
      />
      {content && (
        <BaseLayoutCtaExtra fullWidth={fullWidth}>{content}</BaseLayoutCtaExtra>
      )}
    </BaseLayoutCtaContent>
  </BaseLayoutCtaContainer>
);

BaseLayoutCta.propTypes = {
  indent: PropTypes.bool,
  buttonProps: PropTypes.shape({
    type: PropTypes.string,
  }),
  content: PropTypes.node,
  mt: PropTypes.number,
  mb: PropTypes.number,
  fullWidth: PropTypes.bool,
};

export default BaseLayoutCta;
